import tokens from './tokens';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  tokens
});

export default rootReducer;
